module.exports = __webpack_public_path__ + "img/img26.8b81ae88.svg";